module.exports = __webpack_public_path__ + "static/media/home_events.ffb13a37.jpg";